import script from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=4d2a3b8b&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2a3b8b"]])

export default __exports__